import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {fade, slide} from '../../..';
import {debounceTime, distinctUntilChanged, filter, map, tap} from 'rxjs/operators';
import {GroupConfig} from '../../../models/config';
import * as _ from 'lodash';
import {PlayerFilter} from '../../../../site/models/player-filter';
import {DataConfig} from '../../../models/tabs-data';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import {Params} from '@angular/router';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-generic-filter',
  templateUrl: './generic-filter.component.html',
  styleUrls: ['./generic-filter.component.scss'],
  animations: [fade, slide],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericFilterComponent implements OnInit, OnChanges, OnDestroy {

  @Input() showSearchForm: boolean;
  @Input() filter: PlayerFilter;
  @Input() quickSearchField: string;
  @Input() dataConfig: DataConfig;
  @Input() role: boolean;
  @Output() search = new EventEmitter<{ quickSearch: string } | PlayerFilter | undefined>();
  @Output() toggle = new EventEmitter<boolean>();
  @Output() quickSearch = new EventEmitter<string>();

  searchForm: FormGroup;
  formConfig: GroupConfig;
  quickSearchForm: FormGroup;
  private sub$: Subscription;
  private subscriptions = [];

  constructor(fb: FormBuilder,
              @Inject(L10N_LOCALE) public locale: L10nLocale,
              private cdr: ChangeDetectorRef,
              private store: Store<fromRoot.AppState>) {
    this.quickSearchForm = fb.group({ quickSearch: [] });
  }

  ngOnInit(): void {
    if (this.dataConfig) {
      if (!this.role) {
        this.formConfig = this.dataConfig.groupConfigs.groupConfigs[0];
      } else {
        this.formConfig = this.dataConfig.groupConfigsRole.groupConfigs[0];
      }

      this.searchForm = this.dataConfig.form;
    }
    this.quickSearchPatchOnRouterStateChange();
    this.quickSearchValueChangeEmit();
  }

  quickSearchPatchOnRouterStateChange(): void {
    const sub$ = this.store.pipe(
      select(fromRoot.selectors.getRouterState),
      filter(state => !_.isEmpty(state)),
      map(state => state.queryParams),
      tap((params: Params) => {
        if (params.quickSearch) {
          this.quickSearchForm.get('quickSearch').patchValue(params.quickSearch)
        }
      })
    ).subscribe();
    this.subscriptions.push(sub$)
  }

  quickSearchValueChangeEmit(): void {
    this.sub$ = this.quickSearchForm.get('quickSearch').valueChanges.pipe(
      debounceTime(700),
      distinctUntilChanged()
    ).subscribe(newName => {
      if (newName && newName.length) {
        this.search.emit({ quickSearch: newName });
      } else {
        this.search.emit(undefined);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.inputFilterChanges(changes);
    this.inputQuickSearchFieldChanges(changes);
  }

  inputFilterChanges(changes: SimpleChanges): void {
    if (_.has(changes, 'filter')) {
      const value = this.getCurrentValueFromFilter(changes, 'filter');
      if (!value) {
        this.searchForm.reset();
      }
    }
  }

  inputQuickSearchFieldChanges(changes: SimpleChanges): void {
    if (_.has(changes, 'quickSearchField')) {
      const value = this.getCurrentValueFromFilter(changes, 'quickSearchField');
      if (value) {
        this.quickSearchForm.get('quickSearch').setValue(value);
      }
    }
  }

  getCurrentValueFromFilter(changes: SimpleChanges, key: string): PlayerFilter {
    const change = _.get(changes, key);
    return change.currentValue;
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  applyFilter(form: PlayerFilter): void {
    // tslint:disable-next-line:forin
    // for ( const key in form ) {
    //   if (key && form[key] === 'true') {
    //     form[key] = JSON.parse(this.searchForm.get(key).value);
    //   }
    //   if (key && form[key] === 'false') {
    //     form[key] = JSON.parse(this.searchForm.get(key).value);
    //   }
    // }
    // console.log(form)
    this.search.emit(form);
  }

  reset(): void {
    this.quickSearchForm.reset();
    this.searchForm.reset();
    this.search.emit(undefined);
  }

  toggleSearchForm($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.showSearchForm = !this.showSearchForm;
    this.toggle.emit(!this.showSearchForm);
  }

  showResetQuickSearch(): boolean {
    return !_.isEmpty(this.quickSearchForm.get('quickSearch').value);
  }

  resetQuickSearch($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.quickSearchForm.reset();
    this.search.emit(undefined);
  }

  resetFilter($event?: MouseEvent): void {
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.reset();
    this.search.emit(undefined);
  }
}

